+function ($) {

	"use strict";

	var VideoPlayer = function (toggle) {
		this.toggle = $(toggle);
		this.init();
	};

	VideoPlayer.prototype = {
		constructor: VideoPlayer,

		init: function () {
			this.setHref(this.toggle.get(0).href)
				.createIframe()
				.removeToggle()
				.playVideo();
		},

		createIframe: function () {
			this.iframe = $('<div id="videoPlayerIframe" class="video-player__iframe"/>');
			this.iframe.insertAfter(this.toggle);
			return this;
		},

		removeToggle: function () {
			this.toggle.remove();
			return this;
		},

		playVideo: function () {
			this.player = new YT.Player('videoPlayerIframe', {
				width: '100%',
				height: '100%',
				videoId: this.getYouTubeVideoID(this.getHref()),
				playerVars: {
					rel: 0,
					modestbranding: 1,
					autohide: 1,
					showinfo: 0,
					autoplay: 1
				}
			});
		},

		/**
		 * JavaScript function to match (and return) the video Id
		 * of any valid Youtube Url, given as input string.
		 * @author: Stephan Schmitz <eyecatchup@gmail.com>
		 * @url: http://stackoverflow.com/a/10315969/624466
		 */
		getYouTubeVideoID: function (url) {
			var p = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
			return (url.match(p)) ? RegExp.$1 : false;
		},

		setHref: function (href) {
			this.href = href;
			return this;
		},

		getHref: function () {
			return this.href;
		}
	};

	$(document).on('youTubeAPIReady', function () {
		/**
		 * Since a second click on the toggle is impossible (because it's removed from the page
		 * once it's clicked), we are tying the instance creation to the click event, reducing
		 * the memory footprint while it isn't really necessary.
		 */
		$(document).on('click', '[data-toggle="video-player"]', function () {
			new VideoPlayer(this);
			return false;
		});
	})

}(window.jQuery);
